import { useEffect, useLayoutEffect, useState } from "react"
import pxFromCm from "../util/pxFromCm";
import { GreenHeaderProps } from "../editor/GreenHeaderEditor";
import SvgText from "./SvgText";
import { FooterProps } from "../editor/FooterEditor";
import { AlternativesVP } from "../editor/AlternativesEditor";
import SvgCategoryBubbles from "./SvgCategoryBubbles";
import SvgWidthResizeText from "./SvgWidthResizeText";

interface FlyerContentChildGreenProps {
  headerProps: GreenHeaderProps;
  subheader: string;
  textColor: string;
  footerProps: FooterProps;
  alternatives: AlternativesVP;
}

export default function FlyerContentChildGreen(
  props: FlyerContentChildGreenProps)
{
  const { headerProps, subheader, textColor, footerProps, alternatives } = props;
  const [headerHeight, setHeaderHeight] = useState(-1);
  const [subheaderHeight, setSubheaderHeight] = useState(50);
  const [bubblesHeights, setBubblesHeights] = useState<Record<string, number>>({});
  const [recursion, setRecursion] = useState(0);
  const [fontSize, setFontSize] = useState(110);
  const [extraGap, setExtraGap] = useState(0);

  const margin = pxFromCm(1.25);

  const w = 5 * 702;
  const h = 5 * 496;

  const handleBigHeaderLayout = (capHeight, descent) => {
    setHeaderHeight(capHeight + descent)
  }

  const handleSubheaderLayout = (capHeight, descent) => {
    setSubheaderHeight(capHeight + descent)
  }

  const handleBubbleLayout = (key, height) => {
    setBubblesHeights((prevHeights) => {
      const heights: Record<string, number> = {...prevHeights};
      heights[key] = height
      return heights;
    });
  } 

  useEffect(() => {
    setRecursion(0);
  }, [footerProps, alternatives, subheader, headerHeight])

  const baseGap = 10;
  const bubblesTop = margin + headerHeight * 1.1 + subheaderHeight;
  const sumBubblesHeight = !alternatives ? 0 : alternatives.categories
    .map((c) => c.name)
    .map((key) => bubblesHeights[key] || 0)
    .reduce((sum, value) => sum + value, 0);

  useLayoutEffect(() => {
    const rowCount = alternatives ? alternatives.categories.length : 0;
    if (headerHeight >= 0
      && alternatives
      && Object.keys(bubblesHeights).length >= alternatives.categories.length
    ) {
      const availableHeight = (h - margin - 80) - bubblesTop;
      const remainingHeight = availableHeight - sumBubblesHeight - baseGap * (rowCount - 1) 
      const newExtraGap = remainingHeight / (rowCount + 1);
      setExtraGap(newExtraGap);
      setTimeout(() => {
      }, 0.1)
    }
  }, [headerHeight, footerProps, alternatives, subheader, fontSize, bubblesHeights])

  useEffect(() => {
    if (headerHeight < 0 || recursion >= 20) {
      return;
    }
    if (extraGap < 20) {
      if (fontSize > 50) {
        setBubblesHeights({});
        setFontSize(fontSize - 6);
        setRecursion(recursion + 1);
      }
    } else if (extraGap > 120) {
      if (fontSize < 110) {
        setBubblesHeights({});
        setFontSize(fontSize + 6);
        setRecursion(recursion + 1);
      }
    }
  }, [extraGap])

  return (
    <svg width="100%" height="100%" className="has-custom-font">
      {headerProps && <SvgWidthResizeText 
        text={headerProps.bigHeader}
        color={headerProps.bigColor}
        x={margin}
        capTop={margin}
        width={w - 2 * margin}
        onLayout={handleBigHeaderLayout}
        hasEffect={true}
      />}
      {headerProps && <SvgWidthResizeText 
        text={subheader}
        color={textColor}
        x={margin}
        capTop={margin + headerHeight + 25}
        width={w - 2 * margin}
        onLayout={handleSubheaderLayout}
        hasEffect={true}
      />}
      {footerProps && footerProps.rightText && <SvgText 
        text={footerProps.rightText}
        color={textColor}
        x={w - margin}
        y={h - margin}
        textAnchor="end"
        fontSize={70}
        fontWeight="700"
        hasEffect
      />}
      {footerProps && footerProps.leftText && <SvgText 
        text={footerProps.leftText}
        color={textColor}
        x={margin}
        y={h - margin}
        textAnchor="start"
        fontSize={70}
        fontWeight="700"
        hasEffect
      />}
      {alternatives && alternatives.categories.map((category, index) => (
        <SvgCategoryBubbles
          key={category.name}
          category={category} 
          top={bubblesTop + alternatives.categories.slice(0, index)
            .map((c) => c.name)
            .map((key) => bubblesHeights[key] || 0)
            .reduce((sum, value) => sum + value, 0)
            + (baseGap + extraGap) * index + extraGap
          }
//            bubblesTop + bubblesHeights.slice(0, index).reduce((sum, value) => sum + value, 0) + (baseGap + extraGap) * index + extraGap)} 
          margin={margin}
          fontSize={fontSize}
          textColor={textColor}
          onLayout={(height) => handleBubbleLayout(category.name, height)}
        />
      ))}

      {false && <rect x={margin} y={bubblesTop} width={w - 2 * margin} height={sumBubblesHeight + 2 * extraGap + (baseGap + extraGap) * (bubblesHeights.length - 1)} fill="none" stroke="#50e" strokeWidth={5}
      />}
    </svg>
  )
}